export default () => ({
  flipCameraIcon: {},
});
